import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-student-details',
  templateUrl: './student-details.component.html',
  styleUrls: ['./student-details.component.css']
})
export class StudentDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
